// import CountrySelector from 'components/common/CountrySelector';
import React from 'react';
import FormWrapper from './FormWrapper';
import Selector from 'components/CountrySelector';

const CountrySelector = (props) => {
    const {
        formik,
        i18n,
        index,
        name,
        label,
        title,
        required = false,
        disabled,
        readOnly,
        helper,
        excluedCounties,
    } = props;
    const value = formik.values[name];
    return (
        <FormWrapper {...props}>
            <Selector
                value={value}
                onChangeValue={(value) => formik.setFieldValue(name, value)}
                isDisabled={disabled}
                excluedCounties={excluedCounties}
            />
        </FormWrapper>
    );
};

// export default CountrySelector;

export default React.memo(
    CountrySelector,
    (prev, next) =>{
        const name = prev.name
        return (
            prev.formik.values[name] === next.formik.values[name] &&
            prev.formik.errors[name] === next.formik.errors[name] &&
            prev.formik.touched[name] === next.formik.touched[name] &&
            prev.disabled === next.disabled &&
            prev.i18n === next.i18n
        );
    }
);

